import { createFileRoute } from "@tanstack/react-router"
import { CreateThoughtPage } from "@/pages/diary"

export const Route = createFileRoute("/_authenticated/diary/new")({
	component: CreateThoughtPage,
})
